import React, { Component } from 'react';
import Header from './Header'
import Footer from './Footer'
import Post from './Post'
import PostError from './PostError'
import PostEmpty from './PostEmpty'
import Api from './Api'
import Session from './Session'
import { scroller } from 'react-scroll'

class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      error: null,
      title: null,
      posts: [],
      hasMore: false,
      isLoaded: false
    };

    window.addEventListener('message', function (event) {
      if (event && event.data) {
        if (event.data.name === 'openedSideBar') {
          Api.markUserAsSeen()
        }
      }
    });
  }

  async componentDidMount() {
    const session = Session.getCurrentOptions()
    if (session) {

      this.setState({
        title: (session.app && session.app.title) || null
      })
    
      const { accessToken } = await Api.getAccessToken({
        app: session.app,
        user: session.user
      })
      Api.setAccessToken(accessToken)

      await this.loadPosts()
      const { unseenPostsCount } = await Api.getUserUnseenPostsCount()
      window.parent.postMessage({ action: 'setBadgeCount', count: unseenPostsCount }, '*');
    }
  }

  async loadPosts(publishedBefore) {
    try {
      const posts = await Api.getLatestPosts(publishedBefore)
      this.setState(prevState => {
        const currentPosts = prevState.posts || []
        for (let post of posts) {
          currentPosts.push(post)
        }
        return {
          isLoaded: true,
          posts: currentPosts,
          hasMore: (posts.length === 3)
        }
      }, () => {
        if (this.state.posts.length > 3 && posts.length) {
          scroller.scrollTo(posts[0].id, {
            duration: 1500,
            delay: 100,
            smooth: true
          })
        }
      });
    } catch (error) {
      this.setState({
        isLoaded: true,
        error,
        hasMore: false
      })
    }
  }

  loadMore() {
    const lastPost = this.state.posts[this.state.posts.length - 1]
    this.loadPosts(lastPost.publishedAt)
  }

  render() {
    const { error, isLoaded, posts } = this.state;

    if (error) {
      return (
        <div>
          <section className="main">
              <PostError/>
              <div className="button-container">
                <button type="button" className="button" onClick={() => this.loadPosts()}>
                    Carregar atualizações
                </button>
              </div>
          </section>
        </div>
      )
    } else if (!isLoaded) {
      return <div>Carregando atualizações...</div>
    } else if (posts.length === 0) {
      return (
        <div>
          <section className="main">
              <PostEmpty/>
          </section>
        </div>
      )
    } else {
      return (
        <div>
          <Header title={this.state.title}/>
          <section className="main">
            {posts.map(post => 
              (<Post key={post.id} post={post} />)
            )}
            {this.state.hasMore ? (
              <div className="button-container">
                <button type="button" className="button" onClick={() => this.loadMore()}>
                  Carregar atualizações anteriores
                </button>
              </div>
            ) : null}
          </section>
          <Footer/>
        </div>
      )
    }
  }
}

export default App;
